<template>
  <div class="population-filter-operator-row">
    <div class="flex gap-8">
      {{ label }}
      <BittsDropdownMenu
        :options="OPERATOR_OPTIONS"
        :use-search="false"
        mode="single"
        variant="default"
        :show-checkbox="false"
        :disabled="disabled"
        @selected:options="handleSelect"
      >
        <template #default="{ isOpen: opIsOpen }">
          <button type="button">
            <BittsTag
              :text="operatorLabel"
              size="x-small"
              :class="{ 'cursor-not-allowed': disabled }"
            >
              <template #post>
                <FontAwesomeIcon
                  :icon="['fak', 'chevron-down']"
                  :class="['ml-4', { 'rotate-180': opIsOpen }]"
                />
              </template>
            </BittsTag>
          </button>
        </template>
      </BittsDropdownMenu>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BittsDropdownMenu, BittsTag } from '@crossbeam/bitts';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { computed } from 'vue';

import { POPULATION_OPERATOR_OPTIONS as OPERATOR_OPTIONS } from '@/constants/reports';

const props = withDefaults(
  defineProps<{
    label: string;
    operator: 'OR' | 'AND';
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emit = defineEmits<{
  select: [operator: 'OR' | 'AND'];
}>();

const operatorLabel = computed(
  () =>
    OPERATOR_OPTIONS.find((o) => o.value === props.operator)?.label ??
    'is any of',
);

function handleSelect(ops: { value: string }[]) {
  const op = ops[0]?.value as 'OR' | 'AND';
  if (!op) return;
  emit('select', op);
}
</script>

<style scoped lang="pcss">
@reference "../../css/theme.css";

.population-filter-operator-row {
  @apply flex items-center justify-between p-6 border-b border-neutral-border;
}
</style>
